export interface BibleChapter {
  book: string;
  chapter: number;
  description: string;
  verses: string[];
}

export const bibleData: BibleChapter[] = [
  {
    book: "Genesis",
    chapter: 1,
    description: "The Creation story, emphasizing God as the ultimate origin of the universe and life, a foundational belief shared by all Abrahamic faiths.",
    verses: [
      "In the beginning God created the heaven and the earth.",
      "And the earth was without form, and void; and darkness was upon the face of the deep. And the Spirit of God moved upon the face of the waters.",
      "And God said, Let there be light: and there was light.",
      "And God saw the light, that it was good: and God divided the light from the darkness.",
      "And God called the light Day, and the darkness he called Night. And the evening and the morning were the first day."
    ]
  },
  {
    book: "Psalms",
    chapter: 23,
    description: "A timeless prayer of trust and comfort in God's guidance and provision. It reminds us that with God as our Shepherd, we lack nothing.",
    verses: [
      "The LORD is my shepherd; I shall not want.",
      "He maketh me to lie down in green pastures: he leadeth me beside the still waters.",
      "He restoreth my soul: he leadeth me in the paths of righteousness for his name's sake.",
      "Yea, though I walk through the valley of the shadow of death, I will fear no evil: for thou art with me; thy rod and thy staff they comfort me.",
      "Thou preparest a table before me in the presence of mine enemies: thou anointest my head with oil; my cup runneth over.",
      "Surely goodness and mercy shall follow me all the days of my life: and I will dwell in the house of the LORD for ever."
    ]
  },
  {
    book: "Matthew",
    chapter: 5,
    description: "The Beatitudes: The core of Jesus' ethical teaching, focusing on humility, mercy, purity, and peacemaking—virtues universally revered.",
    verses: [
      "And seeing the multitudes, he went up into a mountain: and when he was set, his disciples came unto him:",
      "And he opened his mouth, and taught them, saying,",
      "Blessed are the poor in spirit: for theirs is the kingdom of heaven.",
      "Blessed are they that mourn: for they shall be comforted.",
      "Blessed are the meek: for they shall inherit the earth.",
      "Blessed are they which do hunger and thirst after righteousness: for they shall be filled.",
      "Blessed are the merciful: for they shall obtain mercy.",
      "Blessed are the pure in heart: for they shall see God.",
      "Blessed are the peacemakers: for they shall be called the children of God."
    ]
  },
  {
    book: "John",
    chapter: 1,
    description: "A profound theological opening identifying the eternal Word (Logos) with God, establishing the divine nature of the message and the messenger.",
    verses: [
      "In the beginning was the Word, and the Word was with God, and the Word was God.",
      "The same was in the beginning with God.",
      "All things were made by him; and without him was not any thing made that was made.",
      "In him was life; and the life was the light of men.",
      "And the light shineth in darkness; and the darkness comprehended it not."
    ]
  },
  {
    book: "1 Corinthians",
    chapter: 13,
    description: "The 'Love Chapter,' defining Love (Charity) as the highest spiritual virtue. It teaches that without love, all other gifts and actions are meaningless.",
    verses: [
      "Though I speak with the tongues of men and of angels, and have not charity, I am become as sounding brass, or a tinkling cymbal.",
      "And though I have the gift of prophecy, and understand all mysteries, and all knowledge; and though I have all faith, so that I could remove mountains, and have not charity, I am nothing.",
      "Charity suffereth long, and is kind; charity envieth not; charity vaunteth not itself, is not puffed up,"
    ]
  }
];
